module.exports = __webpack_public_path__ + "static/media/morphee-mobiles.e2b0aeb0.jpg";